import { render } from "./iconSetting.vue?vue&type=template&id=2b9de992"
import script from "./iconSetting.vue?vue&type=script&lang=js"
export * from "./iconSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__